module.exports = __webpack_public_path__ + "static/media/001-responsive-design.efa9422f.svg";